import clsx from 'clsx';

import useI18n from '@i18n';

import NetworkCard from '@components/pages/home/epnbz/BlockNetwork/NetworkCard';

import styles from '@components/pages/home/epnbz/BlockNetwork/Network.module.scss';

import advertiserImg from '@components/pages/home/epnbz/BlockNetwork/img/advertiser.png';
import epnImg from '@components/pages/home/epnbz/BlockNetwork/img/epn.png';
import webmasterImg from '@components/pages/home/epnbz/BlockNetwork/img/webmaster.png';

import advertiserImgMobile from '@components/pages/home/epnbz/BlockNetwork/img/mobile/advertiser.png';
import epnImgMobile from '@components/pages/home/epnbz/BlockNetwork/img/mobile/epn.png';
import webmasterImgMobile from '@components/pages/home/epnbz/BlockNetwork/img/mobile/webmaster.png';
import { companyName } from '@config/globalDomain';
import { ScreenTypes, useBreakpoints } from '@hooks/useBreakpoints';

const IMAGES = {
    mobile: {
        advertiser: advertiserImgMobile,
        epn: epnImgMobile,
        webmaster: webmasterImgMobile,
    },
    desktop: {
        advertiser: advertiserImg,
        epn: epnImg,
        webmaster: webmasterImg,
    },
};

const mobileImagesCondition = [ScreenTypes.xs, ScreenTypes.sm];

const BlockNetwork: React.FC = () => {
    const { t } = useI18n('Cpa');

    const breakpoint = useBreakpoints();

    const images = mobileImagesCondition.includes(breakpoint) ? IMAGES.mobile : IMAGES.desktop;

    return (
        <section className={styles.landingContainer}>
            <div className={styles.network}>
                <NetworkCard
                    imgSrc={images.webmaster}
                    title={t('Webmaster')}
                    text={t(
                        'Attracts traffic to the advertisers site. When users make a purchase, the webmaster gets a reward',
                    )}
                />
                <div className={styles.network_arrow} />
                <NetworkCard
                    imgSrc={images.epn}
                    title="ePN Affiliate"
                    text={t(
                        'Provides its platform, bringing advertisers and webmasters together. Monitors the quality of traffic and pays rewards',
                    )}
                />
                <div className={clsx(styles.network_arrow, styles.network_arrow__invert)} />
                <NetworkCard
                    imgSrc={images.advertiser}
                    title={t('Advertiser')}
                    text={t('Wants to increase their sales, places their offer on ePN Affiliate.', {
                        companyName,
                    })}
                />
            </div>
        </section>
    );
};

export default BlockNetwork;
